<template>
	<div class="showList">
		<create-show-item v-if="editable"/>
		<div v-bind:key="show.id" v-for="show in showList">
			<ShowItem v-bind:show="show"
					  v-bind:isEditable="editable"
					  v-on:deleteshow="deleteshow"
			/>
		</div>
	</div>
</template>

<script>
	import ShowItem from './ShowItem.vue';
	import CreateShowItem from './CreateShowItem.vue';

	export default {
		name: "ShowList",
		components: {
			ShowItem, 
			CreateShowItem
		},
		props: ["showList", "editable"],
		methods: {
			deleteshow(showId) {
				this.showList = this.showList.filter(show => {
					return show.id != showId;
				});
			}
		}
	}
</script>

<style scoped>
	.showList {
		display: flex;
		flex-wrap: wrap;
	}
</style>